(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Yasr", [], factory);
	else if(typeof exports === 'object')
		exports["Yasr"] = factory();
	else
		root["Yasr"] = factory();
})(window, function() {
return 